import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reporteCC';
import CuentasCobrarClientes from './cuentasCobrarCliente'

const mstp = state => {
    return {...state.ReporteCC, es_cliente: true, permisos: state.login.me.permisos, id_user: state.login.me.id}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(CuentasCobrarClientes)